<script setup lang="ts">
import { computed } from "vue";

interface ExperienceCompanyClientProps {
  company: string;
  client: string | null;
}

const props = defineProps<ExperienceCompanyClientProps>();

const displayClient = computed(() => props.client ?? "Undisclosed");
const shouldShowClient = computed(() => displayClient.value !== props.company);
</script>

<template>
  <p
    class="text-base md:text-lg font-semibold text-primary-700 dark:text-primary-400"
  >
    {{ company }}
    <span
      v-if="shouldShowClient"
      class="text-gray-500 dark:text-gray-400 font-normal text-base"
    >
      · {{ displayClient }}
    </span>
  </p>
</template>
